module.exports = __webpack_public_path__ + "assets/img/home_cs_3.908d8ea5.png";